/* eslint-disable no-use-before-define */
import React, { FC, ReactNode, useState } from 'react';
import { Box, Group, IconCaretDown, IconCaretRight, Wrapper } from '@screentone/core';
import classnames from 'classnames';

import styles from './Accordion.module.scss';

interface AccordionProps {
  title?: string;
  TitleComponent?: JSX.Element;
  children: React.ReactNode;
}

export const Accordion = ({ title, TitleComponent, children }: AccordionProps) => {
  if (title === undefined && TitleComponent === undefined) {
    throw new Error('Accordion component requires either a title or a TitleComponent prop.');
  }

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box
      style={{
        border: 'none'
      }}
    >
      <Box.Title
        componentEl={CustomBoxTitle}
        isOpen={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
        TitleComponent={TitleComponent}
      >
        {title}
      </Box.Title>
      <Box.Content
        className={classnames({
          [styles.accordionContentHidden]: !isOpen
        })}
      >
        {isOpen && <>{children}</>}
      </Box.Content>
    </Box>
  );
};

interface CustomBoxTitleProps {
  className: string;
  onToggle: () => void;
  isOpen: boolean;
  TitleComponent?: JSX.Element;
  children?: ReactNode | undefined;
}

const CustomBoxTitle: FC<CustomBoxTitleProps> = ({
  className,
  children,
  isOpen,
  onToggle,
  TitleComponent
}: CustomBoxTitleProps) => (
  <Wrapper className={classnames(className, styles.accordionTitle)} onClick={onToggle}>
    <Group wrap={false}>
      {isOpen ? <IconCaretDown /> : <IconCaretRight />}
      {TitleComponent ?? children}
    </Group>
  </Wrapper>
);
